// 浠庡師HTML鏂囦欢涓彁鍙栫殑i18n瀵硅薄
// 鑷姩鐢熸垚锛岃鍕挎墜鍔ㄤ慨鏀筡n
export const i18nLegacy = {
            'zh-CN': {
                // 应用标题和基本信息
                appTitle: '无限笔记（Infinite Note）',
                appLogo: '应用图标',
                loadingText: '在有限生命里，遇见那个有趣的自己。',
                
                // 统计信息
                statsText: '项目数: {projects} | 分组数: {groups} | 文本数: {texts}',
                
                // 按钮文本
                btnHelp: '使用说明',
                btnSettings: '设置',
                btnNewCanvas: '新建画布',
                btnAllObjects: '所有东东',
                btnClose: '关闭',
                btnControlMenu: '控制菜单',
                btnRearrange: '重新排列',
                btnDeleteEmpty: '删除空白文本',
                btnDeleteAllTexts: '删除所有文本',
                btnDeleteAllImages: '删除所有图像',
                btnDeleteAllFiles: '删除所有文件',
                btnNewItem: '新建项',
                btnConfirm: '确认',
                btnCancel: '取消',
                btnSave: '保存',
                btnDelete: '删除',
                btnCopy: '复制',
                btnDownload: '下载',
                btnOpen: '打开',
                btnMark: '标记',
                btnUnmark: '取消标记',
                btnComplete: '完成',
                btnUncomplete: '取消完成',
                btnAddAttachment: '添加附件（插入到文本框下方）',
                
                // 菜单项
                menuPaste: '粘贴',
                menuNewText: '新建文本',
                menuUploadFile: '上传文件',
                menuRename: '重命名',
                menuDelete: '删除项目',
                menuDeleteGroup: '删除分组',
                menuCopyText: '复制文本',
                menuCopyImage: '复制图像',
                menuSaveImage: '保存图像',
                menuDeleteImage: '删除图像',
                menuOpenFile: '打开文件',
                menuSaveFile: '保存文件',
                menuDeleteFile: '删除文件',
                
                // 占位符
                placeholderGroupName: '输入分组名称',
                placeholderTextContent: '点击这里输入文本内容...',
                placeholderTextContentSimple: '输入文本内容...',
                placeholderPaste: '在此处粘贴内容...',
                placeholderFileLoading: '正在加载文件...',
                placeholderEnterText: '请输入文本内容',
                
                // 提示信息
                toastDataMigrated: '数据已迁移到 IndexedDB',
                toastFallbackLocalStorage: '已降级到 localStorage 保存',
                toastSaveFailed: '保存失败，数据可能过大',
                toastDeletedObjects: '已删除 {count} 个对象',
                toastCopiedToClipboard: '已复制到剪贴板',
                toastCopiedWithImages: '已复制到剪贴板（包括图像）',
                toastCopyFailed: '复制失败',
                toastContentEmpty: '内容为空',
                toastFileDownloaded: '文件已下载',
                toastFileSaved: '文件已保存',
                toastFileOpened: '已在浏览器中打开文件',
                toastFileNotAvailable: '文件不可用',
                toastFileNotExist: '文件不存在',
                toastImageCopied: '图像已复制到剪贴板',
                toastImageCopyFailed: '复制图像失败，请使用右键菜单保存',
                toastImageSaveFailed: '保存图片失败: {error}',
                toastImageDeleted: '已删除图像',
                toastFileAdded: '已添加文件: {name}',
                toastFilesAdded: '已添加 {count} 个附件',
                toastFileDeleted: '文件已删除',
                toastFileDeleteFailed: '删除文件失败: {error}',
                toastFileSaveFailed: '保存文件失败: {error}',
                toastFileOpenFailed: '打开文件失败: {error}',
                toastFileReadFailed: '读取文件失败: {error}',
                toastFileNeedsIndexedDB: '文件存储需要 IndexedDB 支持',
                toastIndexedDBNotAvailable: 'IndexedDB 不可用',
                toastNoObjectsToView: '没有可查看的对象',
                toastPleaseSelectProject: '请先选择一个项目',
                toastClearedEmptyItems: '已清除 {count} 个空项',
                toastNoEmptyItems: '没有空项需要清除',
                toastPasteHint: '请使用 Ctrl+V 粘贴内容（支持文本、图像和文件）',
                toastOpening: '正在打开: {name}',
                toastDownloading: '正在下载: {name}',
                toastSavingFile: '正在保存文件...',
                toastFileInfoError: '文件信息错误',
                toastRearranged: '已重新排列对象：{texts}个文本、{images}个图片、{files}个文件',
                toastDeletedEmptyTexts: '已删除 {count} 个空白文本',
                toastDeletedTexts: '已删除 {count} 个文本对象',
                toastDeletedImages: '已删除 {count} 个图像对象',
                toastDeletedFiles: '已删除 {count} 个文件对象',
                toastAddedFiles: '已添加 {count} 个文件',
                toastPastedFiles: '已粘贴 {count} 个文件',
                toastUploadedFiles: '已上传 {count} 个文件',
                toastAddImageFailed: '添加图片失败: {error}',
                toastAddFileFailed: '添加文件失败: {error}',
                
                // 确认对话框
                confirmDeleteProject: '确定要删除这个项目吗？项目内的所有内容将被删除。',
                confirmDeleteGroup: '确定要删除这个分组吗？分组内的所有文本将被删除。',
                confirmDeleteFile: '确定要删除这个文件吗？',
                
                // 对话框标题
                dialogEditText: '编辑文本',
                dialogHelp: '使用说明',
                dialogSettings: '设置',
                dialogPasteContent: '粘贴内容',
                dialogDeleteConfirm: '确认删除',
                dialogViewImage: '查看图像',
                dialogViewFile: '查看文件',
                dialogViewTextFile: '查看文本文件',
                
                // 对话框按钮和提示
                btnZoomOut: '缩小',
                btnZoomIn: '放大',
                btnRotate: '顺时针旋转 90°',
                btnCopyImage: '复制图像',
                hintImageControls: '提示: 滚轮缩放 | 拖拽移动 | +/- 缩放 | T 旋转',
                hintFileControls: '提示: 滚轮缩放 | Ctrl+F 搜索',
                emptyText: '(空文本)',
                loadingImage: '加载中...',
                loadingFailed: '加载失败',
                
                // 默认名称
                defaultCanvasName: '新的画布',
                
                // 设置项
                settingLanguage: '语言',
                settingFontSize: '字体大小',
                settingFontFamily: '字体',
                settingShowBorder: '显示外框',
                settingYes: '是',
                settingNo: '否',
                
                // 语言选项
                langZhCN: '简体中文',
                langEnUS: 'English',
                langJaJP: '日本語',
                
                // 帮助文本
                helpTitle: '使用说明',
                helpBasicOps: '基本操作',
                helpClickBlank: '点击空白处 → 直接添加文本输入框',
                helpRightClick: '右键点击空白处 → 粘贴/新建文本/重新排列',
                helpDragDrop: '直接拖放文件/图片到画布 → 自动添加到鼠标位置',
                helpTextOps: '文本操作',
                helpClickText: '点击文本框 → 输入或编辑文字',
                helpDragText: '拖动文本框 → 移动位置',
                helpRightClickText: '右键点击文本框 → 复制/删除',
                helpMultiSelect: '多选操作',
                helpCtrlClick: 'Ctrl+点击 → 多选文本框',
                helpCtrlDrag: 'Ctrl+拖动 → 框选多个文本框',
                helpShiftClick: 'Shift+点击 → 添加到选区',
                helpDeleteSelected: 'Delete键 → 删除选中的文本框',
                
                // 使用提示（首次使用）
                usageTipsTitle: '使用提示',
                usageTipsGotIt: '知道了',
                usageTipClickBlank: '点击空白处 → 直接添加文本输入框',
                usageTipRightClick: '右键点击空白处 → 粘贴/新建文本/重新排列',
                usageTipDragDrop: '直接拖放文件/图片到画布 → 自动添加到鼠标位置',
                usageTipCtrlV: '在画布上按 Ctrl+V → 粘贴到鼠标位置（可重叠）',
                usageTipClickText: '点击文本框 → 输入或编辑文字',
                usageTipDragItem: '拖拽项目任意位置 → 移动位置',
                usageTipPanCanvas: '鼠标中键、空格+左键或Ctrl+左键 → 平移画布',
                usageTipZoomCanvas: 'Ctrl/Cmd + 滚轮 → 缩放画布',
                
                // 帮助对话框章节
                helpCanvasOps: '画布操作',
                helpViewObjects: '查看对象',
                helpEditText: '编辑文本',
                helpShortcuts: '快捷键',
                helpTipAutoSave: '💡 提示：所有数据自动保存到浏览器本地存储，刷新页面不会丢失。',
                helpClickBlankShort: '点击空白处',
                helpRightClickBlank: '右键空白处',
                helpDragDropFiles: '拖放文件/图片',
                helpCtrlV: 'Ctrl+V',
                helpDragItem: '拖拽项目',
                helpPanCanvas: '鼠标中键/空格+左键/Ctrl+左键',
                helpZoomCanvas: 'Ctrl/Cmd + 滚轮',
                helpClickTextImage: '点击文本/图像',
                helpArrowButtons: '左右箭头按钮',
                helpKeyboardArrows: '键盘 ← →',
                helpTextDialog: '文本弹窗',
                helpImageDialog: '图像弹窗',
                helpClickTextShort: '点击文本',
                helpAutoSave: '自动保存',
                helpSwitchClose: '切换/关闭',
                helpEsc: 'Esc',
                helpInImageDialog: '图像弹窗中',
                
                // 其他文本
                unnamed: '未命名',
                unnamedGroup: '未命名分组',
                unnamedProject: '未命名项目',
                welcomeText: '欢迎使用无限笔记！',
                noContent: '暂无内容',
                loading: '加载中...',
                saving: '保存中...',
                
                // 画布座右铭
                canvasMottos: [
                    '笔尖流淌的春天，装得下你所有的奇思妙想',
                    '纸短情长，但这里没有边际',
                    '给思绪一片无垠的旷野',
                    '像收藏阳光一样，收藏你的每一个瞬间',
                    '在无限的画布里，种下你的小世界',
                    '心事无边，画布亦然',
                    '去折腾吧，这片草场够你跑一辈子',
                    '别让围墙，关住了正在发芽的想法',
                    '把零碎的灵感，揉进微风里',
                    '总有一些奇迹，发生在这个无限的角落',
                    '在这儿，每个念头都有它舒展的姿势',
                    '你的思绪是飞鸟，这里是它永不落幕的天空',
                    '万物皆可入画，万象皆有回响',
                    '在有限生命里，遇见那个有趣的自己'
                ],
                
                // 错误信息
                errorIndexedDBNotSupported: '浏览器不支持 IndexedDB',
                errorOpenIndexedDB: '打开 IndexedDB 失败',
                errorLoadSettings: '加载设置失败',
                errorSaveSettings: '保存设置失败',
                errorSaveData: '保存数据失败',
                errorLoadData: '加载数据失败'
            },
            'en-US': {
                // App title and basic info
                appTitle: 'Infinite Note',
                appLogo: 'App Logo',
                loadingText: 'In a finite life, meet that interesting self.',
                
                // Statistics
                statsText: 'Projects: {projects} | Groups: {groups} | Texts: {texts}',
                
                // Button texts
                btnHelp: 'Help',
                btnSettings: 'Settings',
                btnNewCanvas: 'New Canvas',
                btnAllObjects: 'All Objects',
                btnClose: 'Close',
                btnControlMenu: 'Control Menu',
                btnRearrange: 'Rearrange',
                btnDeleteEmpty: 'Delete Empty Texts',
                btnDeleteAllTexts: 'Delete All Texts',
                btnDeleteAllImages: 'Delete All Images',
                btnDeleteAllFiles: 'Delete All Files',
                btnNewItem: 'New Item',
                btnConfirm: 'Confirm',
                btnCancel: 'Cancel',
                btnSave: 'Save',
                btnDelete: 'Delete',
                btnCopy: 'Copy',
                btnDownload: 'Download',
                btnOpen: 'Open',
                btnMark: 'Mark',
                btnUnmark: 'Unmark',
                btnComplete: 'Complete',
                btnUncomplete: 'Uncomplete',
                btnAddAttachment: 'Add Attachment (Insert below text box)',
                
                // Menu items
                menuPaste: 'Paste',
                menuNewText: 'New Text',
                menuUploadFile: 'Upload File',
                menuRename: 'Rename',
                menuDelete: 'Delete Project',
                menuDeleteGroup: 'Delete Group',
                menuCopyText: 'Copy Text',
                menuCopyImage: 'Copy Image',
                menuSaveImage: 'Save Image',
                menuDeleteImage: 'Delete Image',
                menuOpenFile: 'Open File',
                menuSaveFile: 'Save File',
                menuDeleteFile: 'Delete File',
                
                // Placeholders
                placeholderGroupName: 'Enter group name',
                placeholderTextContent: 'Click here to enter text...',
                placeholderTextContentSimple: 'Enter text...',
                placeholderPaste: 'Paste content here...',
                placeholderFileLoading: 'Loading file...',
                placeholderEnterText: 'Please enter text',
                
                // Toast messages
                toastDataMigrated: 'Data migrated to IndexedDB',
                toastFallbackLocalStorage: 'Fallback to localStorage',
                toastSaveFailed: 'Save failed, data may be too large',
                toastDeletedObjects: 'Deleted {count} objects',
                toastCopiedToClipboard: 'Copied to clipboard',
                toastCopiedWithImages: 'Copied to clipboard (with images)',
                toastCopyFailed: 'Copy failed',
                toastContentEmpty: 'Content is empty',
                toastFileDownloaded: 'File downloaded',
                toastFileSaved: 'File saved',
                toastFileOpened: 'File opened in browser',
                toastFileNotAvailable: 'File not available',
                toastFileNotExist: 'File does not exist',
                toastImageCopied: 'Image copied to clipboard',
                toastImageCopyFailed: 'Failed to copy image, please use context menu to save',
                toastImageSaveFailed: 'Failed to save image: {error}',
                toastImageDeleted: 'Image deleted',
                toastFileAdded: 'File added: {name}',
                toastFilesAdded: 'Added {count} attachments',
                toastFileDeleted: 'File deleted',
                toastFileDeleteFailed: 'Failed to delete file: {error}',
                toastFileSaveFailed: 'Failed to save file: {error}',
                toastFileOpenFailed: 'Failed to open file: {error}',
                toastFileReadFailed: 'Failed to read file: {error}',
                toastFileNeedsIndexedDB: 'File storage requires IndexedDB support',
                toastIndexedDBNotAvailable: 'IndexedDB not available',
                toastNoObjectsToView: 'No objects to view',
                toastPleaseSelectProject: 'Please select a project first',
                toastClearedEmptyItems: 'Cleared {count} empty items',
                toastNoEmptyItems: 'No empty items to clear',
                toastPasteHint: 'Use Ctrl+V to paste content (supports text, images, and files)',
                toastOpening: 'Opening: {name}',
                toastDownloading: 'Downloading: {name}',
                toastSavingFile: 'Saving file...',
                toastFileInfoError: 'File info error',
                toastRearranged: 'Rearranged objects: {texts} texts, {images} images, {files} files',
                toastDeletedEmptyTexts: 'Deleted {count} empty texts',
                toastDeletedTexts: 'Deleted {count} text objects',
                toastDeletedImages: 'Deleted {count} image objects',
                toastDeletedFiles: 'Deleted {count} file objects',
                toastAddedFiles: 'Added {count} files',
                toastPastedFiles: 'Pasted {count} files',
                toastUploadedFiles: 'Uploaded {count} files',
                toastAddImageFailed: 'Failed to add image: {error}',
                toastAddFileFailed: 'Failed to add file: {error}',
                
                // Confirm dialogs
                confirmDeleteProject: 'Are you sure you want to delete this project? All content will be deleted.',
                confirmDeleteGroup: 'Are you sure you want to delete this group? All texts will be deleted.',
                confirmDeleteFile: 'Are you sure you want to delete this file?',
                
                // Dialog titles
                dialogEditText: 'Edit Text',
                dialogHelp: 'Help',
                dialogSettings: 'Settings',
                dialogPasteContent: 'Paste Content',
                dialogDeleteConfirm: 'Confirm Delete',
                dialogViewImage: 'View Image',
                dialogViewFile: 'View File',
                dialogViewTextFile: 'View Text File',
                
                // Dialog buttons and hints
                btnZoomOut: 'Zoom Out',
                btnZoomIn: 'Zoom In',
                btnRotate: 'Rotate 90° Clockwise',
                btnCopyImage: 'Copy Image',
                hintImageControls: 'Hint: Scroll to zoom | Drag to move | +/- to zoom | T to rotate',
                hintFileControls: 'Hint: Scroll to zoom | Ctrl+F to search',
                emptyText: '(Empty)',
                loadingImage: 'Loading...',
                loadingFailed: 'Failed to load',
                
                // Default names
                defaultCanvasName: 'New Canvas',
                
                // Settings
                settingLanguage: 'Language',
                settingFontSize: 'Font Size',
                settingFontFamily: 'Font',
                settingShowBorder: 'Show Border',
                settingYes: 'Yes',
                settingNo: 'No',
                
                // Language options
                langZhCN: '简体中文',
                langEnUS: 'English',
                langJaJP: '日本語',
                
                // Help text
                helpTitle: 'Help',
                helpBasicOps: 'Basic Operations',
                helpClickBlank: 'Click blank area → Add text box',
                helpRightClick: 'Right-click blank area → Paste/New text/Rearrange',
                helpDragDrop: 'Drag & drop files/images → Add to canvas',
                helpTextOps: 'Text Operations',
                helpClickText: 'Click text box → Input or edit',
                helpDragText: 'Drag text box → Move position',
                helpRightClickText: 'Right-click text box → Copy/Delete',
                helpMultiSelect: 'Multi-select',
                helpCtrlClick: 'Ctrl+Click → Multi-select',
                helpCtrlDrag: 'Ctrl+Drag → Box select',
                helpShiftClick: 'Shift+Click → Add to selection',
                helpDeleteSelected: 'Delete key → Delete selected',
                
                // Usage tips (first time hint)
                usageTipsTitle: 'Usage Tips',
                usageTipsGotIt: 'Got it',
                usageTipClickBlank: 'Click blank area → Add text box',
                usageTipRightClick: 'Right-click blank area → Paste/New text/Rearrange',
                usageTipDragDrop: 'Drag & drop files/images → Add to canvas',
                usageTipCtrlV: 'Press Ctrl+V on canvas → Paste to mouse position (can overlap)',
                usageTipClickText: 'Click text box → Input or edit',
                usageTipDragItem: 'Drag item → Move position',
                usageTipPanCanvas: 'Middle mouse / Space+Left / Ctrl+Left → Pan canvas',
                usageTipZoomCanvas: 'Ctrl/Cmd + Scroll wheel → Zoom canvas',
                
                // Help dialog sections
                helpCanvasOps: 'Canvas Operations',
                helpViewObjects: 'View Objects',
                helpEditText: 'Edit Text',
                helpShortcuts: 'Shortcuts',
                helpTipAutoSave: '💡 Tip: All data is automatically saved to browser local storage, refreshing the page will not lose data.',
                helpClickBlankShort: 'Click blank area',
                helpRightClickBlank: 'Right-click blank area',
                helpDragDropFiles: 'Drag & drop files/images',
                helpCtrlV: 'Ctrl+V',
                helpDragItem: 'Drag item',
                helpPanCanvas: 'Middle mouse / Space+Left / Ctrl+Left',
                helpZoomCanvas: 'Ctrl/Cmd + Scroll wheel',
                helpClickTextImage: 'Click text/image',
                helpArrowButtons: 'Arrow buttons',
                helpKeyboardArrows: 'Keyboard ← →',
                helpTextDialog: 'Text dialog',
                helpImageDialog: 'Image dialog',
                helpClickTextShort: 'Click text',
                helpAutoSave: 'Auto save',
                helpSwitchClose: 'Switch/Close',
                helpEsc: 'Esc',
                helpInImageDialog: 'In image dialog',
                
                // Other texts
                unnamed: 'Unnamed',
                unnamedGroup: 'Unnamed Group',
                unnamedProject: 'Unnamed Project',
                welcomeText: 'Welcome to Infinite Note!',
                noContent: 'No content',
                loading: 'Loading...',
                saving: 'Saving...',
                
                // Canvas mottos
                canvasMottos: [
                    'Spring flows from the pen, holding all your whimsical thoughts',
                    'Short paper, long feelings, but here there are no boundaries',
                    'Give thoughts an endless wilderness',
                    'Like collecting sunshine, collect every moment of yours',
                    'In the infinite canvas, plant your little world',
                    'Thoughts are boundless, so is the canvas',
                    'Go ahead and explore, this field is big enough for a lifetime',
                    'Don\'t let walls confine ideas that are sprouting',
                    'Gather scattered inspirations into the breeze',
                    'Some miracles happen in this infinite corner',
                    'Here, every thought has its own way to unfold',
                    'Your thoughts are birds, here is their endless sky',
                    'Everything can be painted, everything has its echo',
                    'In a finite life, meet that interesting self'
                ],
                
                // Error messages
                errorIndexedDBNotSupported: 'Browser does not support IndexedDB',
                errorOpenIndexedDB: 'Failed to open IndexedDB',
                errorLoadSettings: 'Failed to load settings',
                errorSaveSettings: 'Failed to save settings',
                errorSaveData: 'Failed to save data',
                errorLoadData: 'Failed to load data'
            },
            'ja-JP': {
                // アプリのタイトルと基本情報
                appTitle: '無限ノート（Infinite Note）',
                appLogo: 'アプリアイコン',
                loadingText: '有限の人生で、面白い自分に出会う。',
                
                // 統計情報
                statsText: 'プロジェクト数: {projects} | グループ数: {groups} | テキスト数: {texts}',
                
                // ボタンテキスト
                btnHelp: '使用説明',
                btnSettings: '設定',
                btnNewCanvas: '新しいキャンバス',
                btnAllObjects: 'すべてのオブジェクト',
                btnClose: '閉じる',
                btnControlMenu: 'コントロールメニュー',
                btnRearrange: '再配置',
                btnDeleteEmpty: '空白テキストを削除',
                btnDeleteAllTexts: 'すべてのテキストを削除',
                btnDeleteAllImages: 'すべての画像を削除',
                btnDeleteAllFiles: 'すべてのファイルを削除',
                btnNewItem: '新しい項目',
                btnConfirm: '確認',
                btnCancel: 'キャンセル',
                btnSave: '保存する',
                btnDelete: '削除',
                btnCopy: 'コピー',
                btnDownload: 'ダウンロード',
                btnOpen: '開く',
                btnMark: 'マーク',
                btnUnmark: 'マーク解除',
                btnComplete: '完了',
                btnUncomplete: '未完了',
                btnAddAttachment: '添付ファイルを追加（テキストボックスの下に挿入）',
                
                // メニュー項目
                menuPaste: '貼り付け',
                menuNewText: '新しいテキスト',
                menuUploadFile: 'ファイルをアップロード',
                menuRename: '名前変更',
                menuDelete: 'プロジェクトを削除',
                menuDeleteGroup: 'グループを削除',
                menuCopyText: 'テキストをコピー',
                menuCopyImage: '画像をコピー',
                menuSaveImage: '画像を保存',
                menuDeleteImage: '画像を削除',
                menuOpenFile: 'ファイルを開く',
                menuSaveFile: 'ファイルを保存',
                menuDeleteFile: 'ファイルを削除',
                
                // プレースホルダー
                placeholderGroupName: 'グループ名を入力',
                placeholderTextContent: 'ここをクリックしてテキストを入力...',
                placeholderTextContentSimple: 'テキストを入力...',
                placeholderPaste: 'ここにコンテンツを貼り付け...',
                placeholderFileLoading: 'ファイルを読み込み中...',
                placeholderEnterText: 'テキストを入力してください',
                
                // トーストメッセージ
                toastDataMigrated: 'データをIndexedDBに移行しました',
                toastFallbackLocalStorage: 'localStorageに保存しました',
                toastSaveFailed: '保存に失敗しました。データが大きすぎる可能性があります',
                toastDeletedObjects: '{count}個のオブジェクトを削除しました',
                toastCopiedToClipboard: 'クリップボードにコピーしました',
                toastCopiedWithImages: 'クリップボードにコピーしました（画像を含む）',
                toastCopyFailed: 'コピーに失敗しました',
                toastContentEmpty: 'コンテンツが空です',
                toastFileDownloaded: 'ファイルをダウンロードしました',
                toastFileSaved: 'ファイルを保存しました',
                toastFileOpened: 'ブラウザでファイルを開きました',
                toastFileNotAvailable: 'ファイルが利用できません',
                toastFileNotExist: 'ファイルが存在しません',
                toastImageCopied: '画像をクリップボードにコピーしました',
                toastImageCopyFailed: '画像のコピーに失敗しました。コンテキストメニューから保存してください',
                toastImageSaveFailed: '画像の保存に失敗しました: {error}',
                toastImageDeleted: '画像を削除しました',
                toastFileAdded: 'ファイルを追加しました: {name}',
                toastFilesAdded: '{count}個の添付ファイルを追加しました',
                toastFileDeleted: 'ファイルを削除しました',
                toastFileDeleteFailed: 'ファイルの削除に失敗しました: {error}',
                toastFileSaveFailed: 'ファイルの保存に失敗しました: {error}',
                toastFileOpenFailed: 'ファイルを開けませんでした: {error}',
                toastFileReadFailed: 'ファイルの読み取りに失敗しました: {error}',
                toastFileNeedsIndexedDB: 'ファイルストレージにはIndexedDBサポートが必要です',
                toastIndexedDBNotAvailable: 'IndexedDBが利用できません',
                toastNoObjectsToView: '表示するオブジェクトがありません',
                toastPleaseSelectProject: '最初にプロジェクトを選択してください',
                toastClearedEmptyItems: '{count}個の空の項目をクリアしました',
                toastNoEmptyItems: 'クリアする空の項目がありません',
                toastPasteHint: 'Ctrl+Vでコンテンツを貼り付けてください（テキスト、画像、ファイルをサポート）',
                toastOpening: '開いています: {name}',
                toastDownloading: 'ダウンロード中: {name}',
                toastSavingFile: 'ファイルを保存中...',
                toastFileInfoError: 'ファイル情報エラー',
                toastRearranged: 'オブジェクトを再配置しました：{texts}個のテキスト、{images}個の画像、{files}個のファイル',
                toastDeletedEmptyTexts: '{count}個の空白テキストを削除しました',
                toastDeletedTexts: '{count}個のテキストオブジェクトを削除しました',
                toastDeletedImages: '{count}個の画像オブジェクトを削除しました',
                toastDeletedFiles: '{count}個のファイルオブジェクトを削除しました',
                toastAddedFiles: '{count}個のファイルを追加しました',
                toastPastedFiles: '{count}個のファイルを貼り付けました',
                toastUploadedFiles: '{count}個のファイルをアップロードしました',
                toastAddImageFailed: '画像の追加に失敗しました: {error}',
                toastAddFileFailed: 'ファイルの追加に失敗しました: {error}',
                
                // 確認ダイアログ
                confirmDeleteProject: 'このプロジェクトを削除してもよろしいですか？すべてのコンテンツが削除されます。',
                confirmDeleteGroup: 'このグループを削除してもよろしいですか？すべてのテキストが削除されます。',
                confirmDeleteFile: 'このファイルを削除してもよろしいですか？',
                
                // ダイアログタイトル
                dialogEditText: 'テキストを編集',
                dialogHelp: '使用説明',
                dialogSettings: '設定',
                dialogPasteContent: 'コンテンツを貼り付け',
                dialogDeleteConfirm: '削除の確認',
                dialogViewImage: '画像を表示',
                dialogViewFile: 'ファイルを表示',
                dialogViewTextFile: 'テキストファイルを表示',
                
                // ダイアログボタンとヒント
                btnZoomOut: '縮小',
                btnZoomIn: '拡大',
                btnRotate: '時計回りに90°回転',
                btnCopyImage: '画像をコピー',
                hintImageControls: 'ヒント: スクロールで拡大縮小 | ドラッグで移動 | +/- で拡大縮小 | T で回転',
                hintFileControls: 'ヒント: スクロールで拡大縮小 | Ctrl+F で検索',
                emptyText: '(空)',
                loadingImage: '読み込み中...',
                loadingFailed: '読み込み失敗',
                
                // デフォルト名
                defaultCanvasName: '新しいキャンバス',
                
                // 設定項目
                settingLanguage: '言語',
                settingFontSize: 'フォントサイズ',
                settingFontFamily: 'フォント',
                settingShowBorder: '枠線を表示',
                settingYes: 'はい',
                settingNo: 'いいえ',
                
                // 言語オプション
                langZhCN: '简体中文',
                langEnUS: 'English',
                langJaJP: '日本語',
                
                // ヘルプテキスト
                helpTitle: '使用説明',
                helpBasicOps: '基本操作',
                helpClickBlank: '空白エリアをクリック → テキストボックスを追加',
                helpRightClick: '空白エリアを右クリック → 貼り付け/新しいテキスト/再配置',
                helpDragDrop: 'ファイル/画像をドラッグ&ドロップ → キャンバスに追加',
                helpTextOps: 'テキスト操作',
                helpClickText: 'テキストボックスをクリック → 入力または編集',
                helpDragText: 'テキストボックスをドラッグ → 位置を移動',
                helpRightClickText: 'テキストボックスを右クリック → コピー/削除',
                helpMultiSelect: '複数選択',
                helpCtrlClick: 'Ctrl+クリック → 複数選択',
                helpCtrlDrag: 'Ctrl+ドラッグ → ボックス選択',
                helpShiftClick: 'Shift+クリック → 選択に追加',
                helpDeleteSelected: 'Deleteキー → 選択した項目を削除',
                
                // 使用ヒント（初回使用時）
                usageTipsTitle: '使用ヒント',
                usageTipsGotIt: '了解しました',
                usageTipClickBlank: '空白エリアをクリック → テキストボックスを直接追加',
                usageTipRightClick: '空白エリアを右クリック → 貼り付け/新しいテキスト/再配置',
                usageTipDragDrop: 'ファイル/画像を直接ドラッグ&ドロップ → マウス位置に自動追加',
                usageTipCtrlV: 'キャンバスで Ctrl+V → マウス位置に貼り付け（重複可能）',
                usageTipClickText: 'テキストボックスをクリック → 入力または編集',
                usageTipDragItem: '項目を任意の位置にドラッグ → 位置を移動',
                usageTipPanCanvas: 'マウス中ボタン、Space+左クリック、Ctrl+左クリック → キャンバスをパン',
                usageTipZoomCanvas: 'Ctrl/Cmd + スクロールホイール → キャンバスをズーム',
                
                // ヘルプダイアログセクション
                helpCanvasOps: 'キャンバス操作',
                helpViewObjects: 'オブジェクトを表示',
                helpEditText: 'テキストを編集',
                helpShortcuts: 'ショートカット',
                helpTipAutoSave: '💡 ヒント：すべてのデータはブラウザのローカルストレージに自動保存され、ページを更新しても失われません。',
                helpClickBlankShort: '空白エリアをクリック',
                helpRightClickBlank: '空白エリアを右クリック',
                helpDragDropFiles: 'ファイル/画像をドラッグ&ドロップ',
                helpCtrlV: 'Ctrl+V',
                helpDragItem: '項目をドラッグ',
                helpPanCanvas: 'マウス中ボタン/Space+左クリック/Ctrl+左クリック',
                helpZoomCanvas: 'Ctrl/Cmd + スクロールホイール',
                helpClickTextImage: 'テキスト/画像をクリック',
                helpArrowButtons: '左右矢印ボタン',
                helpKeyboardArrows: 'キーボード ← →',
                helpTextDialog: 'テキストダイアログ',
                helpImageDialog: '画像ダイアログ',
                helpClickTextShort: 'テキストをクリック',
                helpAutoSave: '自動保存',
                helpSwitchClose: '切り替え/閉じる',
                helpEsc: 'Esc',
                helpInImageDialog: '画像ダイアログ内',
                
                // その他のテキスト
                unnamed: '名前なし',
                unnamedGroup: '名前なしグループ',
                unnamedProject: '名前なしプロジェクト',
                welcomeText: '無限ノートへようこそ！',
                noContent: 'コンテンツなし',
                loading: '読み込み中...',
                saving: '保存中...',
                
                // キャンバスの座右の銘
                canvasMottos: [
                    'ペンから流れる春、あなたのすべての奇想を収める',
                    '紙は短いが、ここには境界がない',
                    '思考に果てしない荒野を与える',
                    '陽光を集めるように、あなたのすべての瞬間を集める',
                    '無限のキャンバスに、あなたの小さな世界を植える',
                    '心は限りなく、キャンバスも同じ',
                    '行って探索しよう、この草原は一生走り回るのに十分',
                    '壁が芽を出しているアイデアを閉じ込めないで',
                    '散らばったインスピレーションを微風に揉み込む',
                    'この無限のコーナーで起こる奇跡がある',
                    'ここで、すべての思考は展開する方法を持っている',
                    'あなたの思考は鳥、ここは彼らの終わりのない空',
                    'すべてが描かれ、すべてがそのエコーを持っている',
                    '有限の人生で、その興味深い自分に会う'
                ],
                
                // エラーメッセージ
                errorIndexedDBNotSupported: 'ブラウザがIndexedDBをサポートしていません',
                errorOpenIndexedDB: 'IndexedDBを開けませんでした',
                errorLoadSettings: '設定の読み込みに失敗しました',
                errorSaveSettings: '設定の保存に失敗しました',
                errorSaveData: 'データの保存に失敗しました',
                errorLoadData: 'データの読み込みに失敗しました'
            }
        };;